// src/shared/components/layout/PageHeader.jsx
// ✅ رأس الصفحة الموحد — Modern Dark Ready
import React from 'react';
import styles from './PageHeader.module.css';

/**
 * @param {string}          title
 * @param {string}          subtitle    — نص ثانوي اختياري
 * @param {React.ReactNode} actions     — أزرار / عناصر تحكم
 */
const PageHeader = ({ title, subtitle, actions }) => (
  <div className={styles.header}>
    <div className={styles.text}>
      <h1 className={styles.title}>{title}</h1>
      {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
    </div>
    {actions && (
      <div className={styles.actions}>{actions}</div>
    )}
  </div>
);

export default PageHeader;